import { initialState } from './state'

export default {
  INIT_GAME (state, { level, history }) {
    state.level = level
    state.history = history
  },

  LOAD_SCRIPT (state, { data, mutations }) {
    const [scene, ...rest] = mutations

    state.data = data
    state.scene = scene
    state.mutations = rest

    if (data) {
      const item = { id: data.id, type: scene.type }
      state.history = [...state.history, item]
    }
  },

  NEXT_SCENE (state) {
    const [mutation, ...mutations] = state.mutations
    state.scene = { ...state.scene, ...mutation }
    state.mutations = mutations
  },

  END_GAME (state) {
    state.isFinished = true
    state.scene.instruction = '3badges'
  },

  SUBMIT_BADGE (state, badge) {
    if (!state.badges.includes(badge)) {
      state.badges = [...state.badges, badge]
    }
  },

  SUBMIT_MANIFEST (state, manifest) {
    if (!state.manifests.includes(manifest)) {
      state.manifests = [...state.manifests, manifest]
    }
  },

  LOAD_ANIMATION (state, type) {
    if (state.scene) {
      state.scene = { ...state.scene, animation: type }
    }
  },

  TOGGLE_MUTE (state) {
    state.isMuted = !state.isMuted
  },

  OVERWRITE (state, props) {
    Object.assign(state, props)
  },

  RESET (state) {
    Object.assign(state, initialState)
  }
}
